import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { QrCode, ChevronDown, ChevronUp } from "lucide-react";

const fmt = (iso) => (iso ? new Date(iso).toLocaleString("en-IN", { dateStyle: "medium", timeStyle: "short" }) : "—");

export function VoucherScanLog({ vtype, vid }) {
  const [data, setData] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    let ok = true;
    api.get(`/voucher-scans/${vtype}/${vid}`)
      .then((r) => { if (ok) setData(r.data); })
      .catch(() => { if (ok) setData(null); });
    return () => { ok = false; };
  }, [vtype, vid]);

  if (!data) return null;

  return (
    <div className="border border-slate-200 bg-slate-50/60 px-4 py-2.5" data-testid="voucher-scan-log">
      <button type="button" onClick={() => data.count > 0 && setOpen((o) => !o)}
        className="w-full flex items-center gap-2 text-left">
        <QrCode size={14} className={data.count > 0 ? "text-emerald-600" : "text-slate-400"} />
        <span className="text-[10px] uppercase tracking-wider font-bold text-slate-500">QR Scan Proof</span>
        {data.count > 0 ? (
          <span className="text-xs text-slate-700" data-testid="scan-log-summary">
            <b className="text-emerald-700">{data.count}</b> scan{data.count > 1 ? "s" : ""} · last {fmt(data.last_scanned_at)}
          </span>
        ) : (
          <span className="text-xs text-slate-400" data-testid="scan-log-summary">Not scanned yet</span>
        )}
        {data.count > 0 && (
          <span className="ml-auto text-slate-400">{open ? <ChevronUp size={13} /> : <ChevronDown size={13} />}</span>
        )}
      </button>
      {open && data.count > 0 && (
        <div className="mt-2 border-t border-slate-200 pt-2 space-y-1" data-testid="scan-log-list">
          {data.scans.map((s, i) => (
            <div key={i} className="flex items-center gap-3 text-xs text-slate-600">
              <span className="tabular-nums">{fmt(s.scanned_at)}</span>
              <span className="text-slate-400 font-mono text-[10px]">{s.ip || ""}</span>
              {(s.city || s.country) && (
                <span className="text-slate-500 text-[10px]">
                  {[s.city, s.country].filter(Boolean).join(", ")}
                </span>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
